import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Clipboard } from '@angular/cdk/clipboard';
import { AiAssistantI18nModule } from '../../../assets/i18n/ai-assistant-i18n.module';

export interface TestToolCallModalData {
  title: string;
  arguments: string;
  response: string;
}

@Component({
  selector: 'ai-test-tool-call-modal',
  templateUrl: './test-tool-call-modal.component.html',
  styleUrl: './test-tool-call-modal.component.scss',
  imports: [MatDialogModule, CommonModule, MatButtonModule, MatIconModule, AiAssistantI18nModule],
})
export class TestToolCallModalComponent {
  readonly dialogRef = inject(MatDialogRef<TestToolCallModalComponent>);
  readonly data = inject<TestToolCallModalData>(MAT_DIALOG_DATA);
  private readonly clipboard = inject(Clipboard);

  parsedArguments: unknown = null;
  parsedResponse: unknown = null;

  constructor() {
    try {
      this.parsedArguments = JSON.parse(this.data.arguments || '{}');
    } catch {
      this.parsedArguments = this.data.arguments;
    }

    try {
      this.parsedResponse = JSON.parse(this.data.response || '{}');
    } catch {
      this.parsedResponse = this.data.response;
    }
  }

  copyArguments(): void {
    this.clipboard.copy(JSON.stringify(this.parsedArguments, null, 2));
  }

  copyResponse(): void {
    this.clipboard.copy(
      typeof this.parsedResponse === 'string' ? this.parsedResponse : JSON.stringify(this.parsedResponse, null, 2),
    );
  }
}
